// extracted by mini-css-extract-plugin
export default {"nav":"activation-nav_nav__iTJuf","active":"activation-nav_active__96KoR","inactive":"activation-nav_inactive__lAuGR"};